module.exports = __webpack_public_path__ + "static/media/minute-maid-orange.d3c81f65.jpg";